import { Box, MenuItem, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { SaldoItemStatus } from '../SaldoItem';

const getBackgroundColor = (status: SaldoItemStatus, theme: any) => {
  if (status === SaldoItemStatus.WARNING) {
    return '#FDEDDE';
  }

  if (status === SaldoItemStatus.DANGER) {
    return '#FAE2E2';
  }

  return 'inherit';
};

type IconWrapperProps = {
  status: SaldoItemStatus;
};

export const CompanySelectMenuItemBoxWrapper = styled(Box)<IconWrapperProps>(({ status, theme }) => ({
  display: 'flex',
  alignContent: 'center',
  gap: 6,
  backgroundColor: getBackgroundColor(status, theme),
  width: '100%',
  padding: '4px 16px'
}));

export const SuccessIconWrapper = styled(CheckCircleIcon)<IconWrapperProps>(({ theme }) => ({
  color: theme.palette.success.dark
}));
